/**
 * Member Portal branding – customize association name, tagline, and colors.
 * Used across login, register, layout, and dashboard.
 */
export const memberPortalBranding = {
  associationName: 'ATUTEIN',
  tagline: 'Your association, connected',
  primaryColor: '#2e7d32',
  primaryLight: '#4caf50',
};
